"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Recurrence_1 = require("./Recurrence");
var widgets_1 = require("@tableau/widgets");
var SelfServiceSchedulePane_1 = require("./SelfServiceSchedulePane");
var HourlyRecurrencePane_1 = require("./panes/HourlyRecurrencePane");
var DailyRecurrencePane_1 = require("./panes/DailyRecurrencePane");
var WeeklyRecurrencePane_1 = require("./panes/WeeklyRecurrencePane");
var MonthlyRecurrencePane_1 = require("./panes/MonthlyRecurrencePane");
var typestyle_1 = require("typestyle");
var Localize_1 = require("../../gen-src/Localize");
var StaticInitializers_1 = require("./StaticInitializers");
var RecurrenceOptionsOverlayId = 'recurrenceOptionsOverlay';
var RecurrenceUxStyle = {
    display: 'flex',
    flexFlow: 'wrap',
    flexBasis: '464px',
    marginTop: '18px'
};
var RecurrenceOptionsOverlay = /** @class */ (function (_super) {
    __extends(RecurrenceOptionsOverlay, _super);
    function RecurrenceOptionsOverlay(props, context) {
        var _this = _super.call(this, props, context) || this;
        /* HANDLERS */
        _this.recurrenceTypeChangedHandler = function (recType) { return _this.onRecurrenceTypeChanged(recType, _this.props.type); };
        _this.recurrenceDetailsChangedHandler = function (newDetails) { return _this.onRecurrenceDetailsChange(newDetails); };
        return _this;
    }
    /* END OF HANDLERS */
    RecurrenceOptionsOverlay.prototype.renderRecurrenceTypeDropDown = function () {
        return (React.createElement(widgets_1.SingleSelectDropdown, { type: widgets_1.DropdownButtonType.Line, label: Localize_1.Messages.RecurrenceCaptionRepeats(), className: typestyle_1.style({
                marginTop: '18px',
                marginBottom: '18px',
                flex: '1 2 165px',
            }), value: this.getRecurrenceTypeDataLocValue(this.props.recurrenceModel.recurrenceType), onChange: this.recurrenceTypeChangedHandler, testId: 'RecurrenceType-line', list: this.getRecurrenceTypeData() }));
    };
    ;
    RecurrenceOptionsOverlay.prototype.getRecurrenceTypeDataLocValue = function (recurrenceType) {
        switch (recurrenceType) {
            case Recurrence_1.RecurrenceType.Daily: {
                return Localize_1.Messages.RecurrenceDaily();
            }
            case Recurrence_1.RecurrenceType.Monthly: {
                return Localize_1.Messages.RecurrenceMonthly();
            }
            case Recurrence_1.RecurrenceType.Weekly: {
                return Localize_1.Messages.RecurrenceWeekly();
            }
            case Recurrence_1.RecurrenceType.Hourly:
            default: {
                return Localize_1.Messages.RecurrenceHourly();
            }
        }
    };
    RecurrenceOptionsOverlay.prototype.getRecurrenceTypeData = function () {
        var results = [];
        results.push({ value: Recurrence_1.RecurrenceType.Hourly, content: Localize_1.Messages.RecurrenceHourly() });
        results.push({ value: Recurrence_1.RecurrenceType.Daily, content: Localize_1.Messages.RecurrenceDaily() });
        results.push({ value: Recurrence_1.RecurrenceType.Weekly, content: Localize_1.Messages.RecurrenceWeekly() });
        results.push({ value: Recurrence_1.RecurrenceType.Monthly, content: Localize_1.Messages.RecurrenceMonthly() });
        return React.createElement(widgets_1.List, { items: results, style: { maxHeight: '300px', overflow: 'auto' } });
    };
    RecurrenceOptionsOverlay.prototype.onRecurrenceTypeChanged = function (recType, paneType) {
        // Theres probably a way to make this function neater but for now
        // we don't prove to typescript that the result is valid, and simply
        // assert that it is by casting to Recurrence at the end
        var roundToNearestMinutes = paneType === SelfServiceSchedulePane_1.SelfServiceSchedulePaneType.BridgeExtractRefresh
            ? StaticInitializers_1.StaticInitializers.MINUTES_IN_HOUR
            : 5;
        switch (recType) {
            case Recurrence_1.RecurrenceType.Hourly:
                this.props.recurrenceModelChangedCallback(__assign({}, this.props.recurrenceModel, { recurrenceType: Recurrence_1.RecurrenceType.Hourly, recurrenceDetails: StaticInitializers_1.StaticInitializers.defaultHourly(roundToNearestMinutes) }));
                break;
            case Recurrence_1.RecurrenceType.Daily:
                this.props.recurrenceModelChangedCallback(__assign({}, this.props.recurrenceModel, { recurrenceType: Recurrence_1.RecurrenceType.Daily, recurrenceDetails: StaticInitializers_1.StaticInitializers.defaultDaily(roundToNearestMinutes) }));
                break;
            case Recurrence_1.RecurrenceType.Weekly:
                this.props.recurrenceModelChangedCallback(__assign({}, this.props.recurrenceModel, { recurrenceType: Recurrence_1.RecurrenceType.Weekly, recurrenceDetails: StaticInitializers_1.StaticInitializers.defaultWeekly(roundToNearestMinutes) }));
                break;
            case Recurrence_1.RecurrenceType.Monthly:
                this.props.recurrenceModelChangedCallback(__assign({}, this.props.recurrenceModel, { recurrenceType: Recurrence_1.RecurrenceType.Monthly, recurrenceDetails: StaticInitializers_1.StaticInitializers.defaultMonthly(roundToNearestMinutes) }));
                break;
            default:
                throw recType + ' is not implemented yet!';
        }
    };
    RecurrenceOptionsOverlay.prototype.onRecurrenceDetailsChange = function (newDetails) {
        // Cast because it isn't garuanteed in the typesystem that it will have the right fields for the type
        var newRecurrence = __assign({}, this.props.recurrenceModel, { recurrenceDetails: newDetails });
        this.props.recurrenceModelChangedCallback(newRecurrence);
    };
    RecurrenceOptionsOverlay.prototype.getRecurrenceUX = function () {
        return (React.createElement("div", { style: RecurrenceUxStyle },
            this.renderRecurrenceTypeDropDown(),
            " ",
            this.getRecurrencePane()));
    };
    RecurrenceOptionsOverlay.prototype.getRecurrencePane = function () {
        switch (this.props.recurrenceModel.recurrenceType) {
            case Recurrence_1.RecurrenceType.Hourly:
                return (React.createElement(HourlyRecurrencePane_1.HourlyRecurrencePane, { recurrenceDetails: this.props.recurrenceModel.recurrenceDetails, recurrenceDetailsChangedCallback: this.recurrenceDetailsChangedHandler, timeZoneDetails: this.props.timeZoneDetails, type: this.props.type }));
            case Recurrence_1.RecurrenceType.Daily:
                return (React.createElement(DailyRecurrencePane_1.DailyRecurrencePane, { recurrenceDetails: this.props.recurrenceModel.recurrenceDetails, recurrenceDetailsChangedCallback: this.recurrenceDetailsChangedHandler, timeZoneDetails: this.props.timeZoneDetails, type: this.props.type }));
            case Recurrence_1.RecurrenceType.Weekly:
                return (React.createElement(WeeklyRecurrencePane_1.WeeklyRecurrencePane, { recurrenceDetails: this.props.recurrenceModel.recurrenceDetails, recurrenceDetailsChangedCallback: this.recurrenceDetailsChangedHandler, timeZoneDetails: this.props.timeZoneDetails, type: this.props.type }));
            case Recurrence_1.RecurrenceType.Monthly:
                return (React.createElement(MonthlyRecurrencePane_1.MonthlyRecurrencePane, { RecurrenceOptionsOverlayId: RecurrenceOptionsOverlayId, recurrenceDetails: this.props.recurrenceModel.recurrenceDetails, recurrenceDetailsChangedCallback: this.recurrenceDetailsChangedHandler, timeZoneDetails: this.props.timeZoneDetails, type: this.props.type }));
            default:
                return (React.createElement("div", null,
                    React.createElement("h1", null, "Not implemented yet!")));
        }
    };
    RecurrenceOptionsOverlay.prototype.render = function () {
        return (this.getRecurrenceUX());
    };
    return RecurrenceOptionsOverlay;
}(React.Component));
exports.RecurrenceOptionsOverlay = RecurrenceOptionsOverlay;
//# sourceMappingURL=RecurrenceOptionsOverlay.js.map